import { render, staticRenderFns } from "./TermoDesentranhamentoRedigirGenerico.vue?vue&type=template&id=71f7a614"
import script from "./TermoDesentranhamentoRedigirGenerico.vue?vue&type=script&lang=js"
export * from "./TermoDesentranhamentoRedigirGenerico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports